
export class ParkingSpot {
    constructor(
        public id: number = null,
        public parkingNumber: string = '',
        public level: string = '',
        public legalDescription: string = '',
        public rentedOut: number = 0,
        public rentedTo: string = '',
        public garageRemote: string = '',
        public handicap: string = '',
        public note: string = '',
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public extendedRentedTo: any = {},
        public formFields = {
            location: {editMode: false},
            parkingNumber: {editMode: false},
            level: {editMode: false},
            rentedOut: {editMode: false},
            rentedTo: {editMode: false},
            rentedToBuilding: {editMode: false},
            rentedToSuite: {editMode: false},
            rentedToSuiteUser: {editMode: false},
            garageRemote: {editMode: false},
            handicap: {editMode: false},
            legalDescription: {editMode: false},
            note: {editMode: false}
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ParkingSpot.ts